import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";

const selectors = {
  upsellProduct: '[data-upsell-product]:not(.disabled)',
  upsellContainer: '.free_upsell-card-products',
  checkoutButton: 'button[name="checkout"]',
  checkoutFreeShippingModal: '[data-popup-trigger]',
  checkoutGiftOneModal: '#giftOneModal',
  checkoutGiftTwoModal: '#giftTwoModal',
  cartWrapper: '.cart-recap__scroller'
};

const shippingModal = document.querySelectorAll(selectors.checkoutFreeShippingModal)

function registerCart() {
  // Check gifts in cart
  checkGiftsInCart();
  $(selectors.upsellContainer).removeClass('is-loading');

  registerCheckoutListener();
  // We clear the cart attributes when not on cart page since discount resets itself
  if ( window.routes.cartUrl !== window.location.pathname ){
    if ( !!window.theme.cartDiscount ){
      removeDiscount(false);
    }
  }
}

function triggerLoadingState() {
  $(selectors.upsellContainer).addClass('is-loading');
}

function checkGiftsInCart() {
  const scriptVariables = document.getElementById('cartVariables');
  if (!!!scriptVariables) {
    return
  }
  const variableJson = JSON.parse(scriptVariables.textContent);

  
  const giftOneVariant = variableJson.selected_gift_tier_1.toString();
  const giftOneCount = parseInt(variableJson.selected_gift_count_1);
  const giftOneKey = variableJson.selected_gift_key_1.toString();
  const giftTwoVariant = variableJson.selected_gift_tier_2.toString();
  const giftTwoCount = parseInt(variableJson.selected_gift_count_2);
  const giftTwoKey = variableJson.selected_gift_key_2.toString();
  const giftTotalCount = parseInt(variableJson.total_gift_counter);
  const giftOneAvailable = variableJson.gift_tier_one_reached;
  const giftTwoAvailable = variableJson.gift_tier_two_reached;

  // If there's more than 1 gift one selected, remove it
  if ( giftOneCount > 1 && giftOneVariant != "false" ) {
    removeCartUpsell(giftOneKey)
  }
  // If there's more than 1 gift two selected, remove it
  if ( giftTwoCount > 1 && giftTwoVariant != "false" ) {
    triggerLoadingState()
    removeCartUpsell(giftTwoKey)
  }

  // If tier 1 isn't reached and gift 1 exists, remove it
  if ( giftOneAvailable == false && giftOneVariant != "false") {
    triggerLoadingState()
    removeCartUpsell(giftOneKey)
  }
  // If tier 2 isn't reached and gift 2 exists, remove it
  if ( giftTwoAvailable == false && giftTwoVariant != "false") {
    triggerLoadingState()
    removeCartUpsell(giftTwoKey)
  }
}

var _cart = []
var selected_gifts = []
var gift_level_one_threshold = window.theme.cartGiftTierOne
var gift_level_two_threshold = window.theme.cartGiftTierTwo
var updates = []
function addCartUpsell(){
  _cart = []
  selected_gifts = []
  $.getJSON('/cart.js').then(function(cart) {
    _cart = cart
    var product_calls = cart.items.map(function(item){
      return item
    })

    Promise.all(product_calls).then(function(products){
      products.forEach(function(product){
        if (!!product.properties.__gift_threshold) {
          selected_gifts[0] = product.properties.__gift_threshold.includes(gift_level_one_threshold)?product.variant_id:selected_gifts[0]
          selected_gifts[1] = product.properties.__gift_threshold.includes(gift_level_two_threshold)?product.variant_id:selected_gifts[1]
        }
      })
    })
  })
  
  $(selectors.upsellProduct).on('click', e => {
    const variantId = e.currentTarget.getAttribute('data-upsell-product');
    const giftStage = e.currentTarget.getAttribute('data-gift-stage');
    const giftLevel = e.currentTarget.getAttribute('data-gift-level');
    const alreadyInCart = e.currentTarget.getAttribute('data-in-cart');
    let replaceProdId = null

    if (!!selected_gifts[giftLevel]){
     replaceProdId = selected_gifts[giftLevel];
    }

    function addItem() {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
          data: {
              quantity: 1,
              id: variantId,
              properties: {
                '__gift_stage': giftStage,
                '__gift_threshold': giftStage === "stage_1" ? gift_level_one_threshold : gift_level_two_threshold,
              }
          },
          dataType: 'json',
          success: function () {
          window.location.reload();
          },
          error: function () {
            window.location.reload();
          }
      })
    }

    if (replaceProdId) {
       jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: replaceProdId,
          quantity: 0
        },
        dataType: 'json',
        success: function () {
          if (alreadyInCart == 'false') {
            addItem()
          }
        }
      }); 
    }
    else {
      if (alreadyInCart == 'false') {
        addItem()
      }
    }
  })
}
// function addFreeGift(variantId,giftStage){
//   var gift_level_one_threshold = window.theme.cartGiftTierOne
//   var gift_level_two_threshold = window.theme.cartGiftTierTwo

//   let formData = {
//     items: [{
//       id: variantId,
//       quantity: 1,
//       properties: {
//         '__gift_stage': giftStage,
//         '__gift_threshold': giftStage === "stage_1" ? gift_level_one_threshold : gift_level_two_threshold,
//       }
//     }],
//   };
//   triggerLoadingState()
//   // Add items via helpers file
//   Helpers.addCartItems(formData).then((response) => {
//     if (response.status === 200) {
//       window.location.reload();
//     }
//   });
// }
function removeCartUpsell(variantId) {
  Helpers.removeCartItem(variantId).then((response) => {
    if (response.status === 200) {
      window.location.reload();
    }
  });
}

function evaluatedDiscount(payload){
  if (payload.valid === true && !!!payload.cart.attributes.discount_code || discountedAmount != payload.discount ) {
    // code, discount amount, discounted subtotal
    Helpers.setCookie("discount_code", payload.discount_code, 365);
    Helpers.updateCartAttributes(payload.discountCode, payload.discount, payload.subtotal, true)
  } else {
    // $('.cart-skeleton-container').removeClass('is-loading')
  }
}

function removeDiscount(refresh){
  triggerLoadingState()
  Helpers.updateCartAttributes("", "", "", refresh)
}



function registerCheckoutListener() {
  
  // Handle modals
  $(selectors.checkoutButton).on('click', e => {
    const checkoutShippingSession = sessionStorage.getItem("shipping-modal");
    const checkoutGiftOneSession = sessionStorage.getItem("checkout-modal-gift-one");
    const checkoutGiftTwoSession = sessionStorage.getItem("checkout-modal-gift-two");

  
    const giftOneModal = $(selectors.checkoutGiftOneModal)
    const giftTwoModal = $(selectors.checkoutGiftTwoModal)


    if ( !!!checkoutGiftOneSession && !!giftOneModal.length ) {
      e.preventDefault();
      triggerCheckoutModal(selectors.checkoutGiftOneModal, "checkout-modal-gift-one");
    }
    if ( !!!checkoutGiftTwoSession && !!giftTwoModal.length ) {
      e.preventDefault();
      triggerCheckoutModal(selectors.checkoutGiftTwoModal, "checkout-modal-gift-two");
    }
    const checkoutFreeShippingPopUp = document.getElementById('upsellModal--shipping')
    if ( !!!checkoutShippingSession && !!shippingModal.length && !!checkoutFreeShippingPopUp) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('modal:opened'))
      triggerCheckoutModal(checkoutFreeShippingPopUp, "shipping-modal")
    }

  })
  const sessionFirstGiftsTrigger = sessionStorage.getItem("shipping-modal-first-gift");
  const sessionSecndGiftsTrigger = sessionStorage.getItem("shipping-modal-second-gift");
  const giftNotReachedFirst = document.querySelector('.gift_not_reached_popup_first')
  const giftNotReachedsecond = document.querySelector('.gift_not_reached_popup_second')

  if(!!giftNotReachedFirst){
    giftNotReachedFirst.addEventListener('click', function(e){
      if (!!!sessionFirstGiftsTrigger && !!shippingModal.length ) {
        e.preventDefault();
        shippingModal.forEach(modal =>{
          if (!!modal.getAttribute('data-popup-trigger')) {
            if (modal.getAttribute('data-popup-trigger') === 'gifts_first_threshold') {
              const checkoutFreeShippingPopUpFirst = document.getElementById('upsellModal--gifts_first_threshold')
              document.dispatchEvent(new CustomEvent('modal:shipping:open', {detail: { trigger: 'gifts_first_threshold' }}))
              document.dispatchEvent(new CustomEvent('modal:opened'))
              triggerCheckoutModal(checkoutFreeShippingPopUpFirst, "shipping-modal-first-gift")
            }
          }
        })
      }
    })
  }

  if(!!giftNotReachedsecond){
    giftNotReachedsecond.addEventListener('click', function(e){
      if (!!!sessionSecndGiftsTrigger && !!shippingModal.length ) {
        e.preventDefault();
        shippingModal.forEach(modal =>{
          if (!!modal.getAttribute('data-popup-trigger')) {
            if (modal.getAttribute('data-popup-trigger') === 'gifts_second_threshold') {
              const checkoutFreeShippingPopUpSecond = document.getElementById('upsellModal--gifts_second_threshold')
              document.dispatchEvent(new CustomEvent('modal:shipping:open', {detail: { trigger: 'gifts_second_threshold' }}))
              document.dispatchEvent(new CustomEvent('modal:opened'))
              triggerCheckoutModal(checkoutFreeShippingPopUpSecond, "shipping-modal-second-gift")
            }
          }
        })
      }
    })
  }
}
function triggerCheckoutModal(modalElement, sessionItem){

  const modal = $(modalElement);
  // If modal exists, we open it. Whether it exists is handled by liquid
  if( !!modal.length ){
      modal.attr("aria-hidden", false)
      document.dispatchEvent(new CustomEvent('modal:opened'))
      document.querySelector('html').classList.add('modal--open')
      modal.find('[data-action="close-modal"]').on("click", e => {
        document.querySelector('html').classList.remove('modal--open')
        modal.attr("aria-hidden", true)
      })
    // Check if we click outside the modal
    $(document.body).on('click', e => {
      if($(e.target).is(modal)){
        modal.attr("aria-hidden", true)
        document.querySelector('html').classList.remove('modal--open')
        $(document.body).off('click');
      }
    });
  }
const showModalOnce = modal.attr("data-show-once")
  if(!!showModalOnce && showModalOnce === 'true'){
    sessionStorage.setItem(sessionItem, true)
  }
}

document.addEventListener("DOMContentLoaded", function () {
  registerCart();
  addCartUpsell()
});

window.addEventListener('discountz', (event) => {
  if (!(event instanceof CustomEvent)) return;

  switch (event.detail.type) {
    case 'discount-cleared':
      // handle Discount Cleared event
      removeDiscount(true);
      break;

    case 'discount-submitted':
      // handle Discount Submitted event
      break;

    case 'discount-evaluated':
      // handle Discount Evaluated event
      evaluatedDiscount(event.detail.payload);
      break;
  }
});




document.addEventListener('cart:rerendered', function(){
  registerCart()
  addCartUpsell()
});



// Loading state for the cart
document.addEventListener('theme:loading:start', function(){
  $(selectors.cartWrapper).addClass('is-loading')
});
document.addEventListener('theme:loading:end', function(){
  $(selectors.cartWrapper).removeClass('is-loading')
});